import SettingsSummaryCard, { SettingDetail } from '../settings-summary-card/SettingsSummaryCard';
import { useTranslation } from 'react-i18next';
import { ReactElement, useMemo } from 'react';
import { useGetUiSettingsQuery } from '@casops/store/apis/settingsApi';
import { SettingsSidePanelTab } from '@casops/store/slices/globalSlice';

export const SiteDetailsSettings = (): ReactElement => {
  const { t } = useTranslation();

  const { currentData: uiSettings } = useGetUiSettingsQuery();

  const settings = useMemo<SettingDetail[]>(() => {
    const siteName = uiSettings?.siteName;

    const settings: SettingDetail[] = [[t('Fields.SiteName'), siteName ?? undefined]];

    return settings;
  }, [t, uiSettings]);

  return (
    <SettingsSummaryCard
      title={t('Navigation.SiteDetails')}
      settings={settings}
      sidePanelTab={SettingsSidePanelTab.SiteDetails}
    />
  );
};

export default SiteDetailsSettings;
